import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { HomeCharacteristics, HomeOperatingConditions, OtherConditions } from '../models/user-inputs';
import { UserInputsService } from '../services/user-inputs.service';

@Component({
  selector: 'app-about-my-home',
  templateUrl: './about-my-home.component.html',
  styleUrls: ['./about-my-home.component.css']
})
export class AboutMyHomeComponent implements OnInit {

  homeCharacteristics!: HomeCharacteristics;
  homeOperatingConditions!: HomeOperatingConditions;
  otherConditions!: OtherConditions;
  
  constructor(
    private router: Router,
    private userInputsService: UserInputsService
  ) { }

  ngOnInit(): void {
    this.homeCharacteristics = {...this.userInputsService.homeCharacteristics};
    this.homeOperatingConditions = {...this.userInputsService.homeOperatingConditions};
    this.otherConditions = {...this.userInputsService.otherConditions};
  }
  
  updateHouseType(): void {
    if (this.homeCharacteristics.typeOfHouse == 2) {
      this.homeCharacteristics.windShelteringOfHouse = 5;
    }
  }

  save(): void {
    this.userInputsService.homeCharacteristics = {...this.homeCharacteristics};
    this.userInputsService.homeOperatingConditions = {...this.homeOperatingConditions};
    this.userInputsService.otherConditions = {...this.otherConditions};
    this.router.navigate([''], { skipLocationChange: true });
  }
}
